import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=0d74c964"
import script from "./CookieBar.vue?vue&type=script&lang=js"
export * from "./CookieBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports